import useCheckAuth from './useCheckAuth';
import { UserRole } from '../constants';

export const useCabinetMenuAccess = () => {
  const { role, isAuthReady } = useCheckAuth();
  const allowedMenuPaths = ['/overview', '/ads-history'];

  const canAccessMenu = (menuPath: string): boolean => {
    if (!isAuthReady || !role) return false;

    // Staff and Superuser can access everything
    if (role === UserRole.STAFF || role === UserRole.SUPERUSER) {
      return true;
    }

    // Regular users can only access 'ads-history'
    if (role === UserRole.USER) {
      return allowedMenuPaths.includes(menuPath);
    }

    return false;
  };

  return {
    canAccessMenu,
    isAuthReady,
    role,
  };
};
